export class HoleFilter {
    containHole
    filterType = 'hole'
    constructor(containHole) {
        this.containHole = containHole
    }

    apply(products) {
        return products.filter(product => {
            return (product.Agujero.toLowerCase().trim() === this.containHole.toLowerCase().trim())
        })
    }
}